import * as Yup from 'yup'

export const StreetFormSchema = Yup.object().shape({
    name: Yup.string()
        .matches(/^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/g,'Solo se pueden ingresar letras.')
        .max(30, 'Máximo 30 caracteres').required('Ingrese un nombre válido.'),
    email: Yup.string().email().required('El correo electrónico es necesario.')
})

export const PlacesFormSchema = Yup.object().shape({
    name: Yup.string()
        .matches(/^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/g,'Solo se pueden ingresar letras.')
        .max(30, 'Máximo 30 caracteres').required('Ingrese un nombre válido.'),
    email: Yup.string().email().required('El correo electrónico es necesario.'),
    place: Yup.string().max(20, 'Máximo 20 caracteres').required('Ingrese un lugar válido.'),
    phone: Yup.string().max(20, 'Máximo 20 caracteres')
})